<mat-tab-group>
    
    <mat-tab label="Steering Commitee">
      <ng-template mat-tab-label>
        <img width="30" src="assets/img/icontab/speaker.png" alt="" srcset="">
 
        Steering Commitee
      </ng-template>
      
      <app-steering></app-steering> 
    </mat-tab>
    <mat-tab label="Programme">
        <ng-template mat-tab-label>
          <img width="30" src="assets/img/icontab/speaker.png" alt="" srcset="">
   
          Programme
        </ng-template>
        
        <app-programme></app-programme> 
      </mat-tab>
    
 
  </mat-tab-group>

